export const CREATE = "create";
export const EDIT = "edit";
export const CUSTOM_EDIT = "custom-edit";
export const DRAFT_CREATE = "draft-create";
export const DRAFT_EDIT = "draft-edit";
